/* The words for a campaign's enrichment, and the expected finish of work that
 * is running. A stage's words are STAGE_WORDS in campaign.ts.
 *
 * The engine stores the request's requested, in_progress and complete
 * (migration 157). These are the words a person reads for each. Nothing here
 * decides anything: the engine refuses enrichment on a Calling campaign
 * itself, and the screens say why before the press so nobody has to meet the
 * refusal. */

/* Said beside the enrichment buttons on a campaign that is sent to no
   enrichment, in the engine's own words. Null when enrichment is allowed. */
export function enrichmentRule(status: string | null | undefined): string | null {
  if (status === "calling") return CALLING_RULE;
  if (status === "completed" || status === "abandoned") {
    return `This campaign is ${status}. Move it to Enriching to send it to enrichment.`;
  }
  return null;
}

/* Said beside Automatic web enrichment and Request manual enrichment on a
   campaign in Planning, whose enrichment starts with Start enrichment or on
   its date. The engine refuses both there (migration 259). */
export const PLANNING_RULE = "This campaign is in Planning. Start enrichment at the top of the page.";

export const REQUEST_WORDS: Record<string, string> = {
  requested:   "Requested",
  in_progress: "In progress",
  complete:    "Complete",
};

/* Said beside every enrichment button on a Calling campaign, in the engine's
   own words, so the person reads the rule rather than meeting the refusal. */
export const CALLING_RULE = "This campaign is being called. Move it to Enriching to send it to enrichment.";

/* When running work is expected to finish, from a time the engine computed
 * (api.enrichment_batch.expected_done_at, api.job.expected_done_at). The
 * engine leaves it null when it has no pace to compute from, and the screen
 * says so rather than guessing. Today's times read as a clock time, later
 * ones with their day. */
export function expectedWords(iso: string | null | undefined): string {
  if (!iso) return "pace not measured yet";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "pace not measured yet";
  const now = new Date();
  const sameDay = d.getFullYear() === now.getFullYear() && d.getMonth() === now.getMonth()
    && d.getDate() === now.getDate();
  const time = d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  if (d.getTime() <= now.getTime()) return "any moment";
  return sameDay ? `expected by ${time}` : `expected by ${time} on ${d.toLocaleDateString(undefined, { month: "short", day: "numeric" })}`;
}
